<!-- @format -->

<template>
	<template v-if="previewType === 'image'">
		<el-image-viewer v-if="visable" :url-list="[fileUrl]" :initial-index="0" @close="visable = false" />
	</template>
	<!-- <pc-dialog
		v-else
		v-model="visable"
		destroy-on-close
		:close-on-click-modal="false"
		:title="fileName"
		:width="width"
		:show-footer="false"
		:can-full-screen="true"
	>
		<iframe
			:id="id"
			frameborder="0"
			:src="`/power-front-base/power-file-preview?id=${id}&name=${fileName}`"
			:style="{ width: '100%', height: '100%', 'min-height': '65vh' }"
		/>
	</pc-dialog> -->
</template>

<script setup>
	import { getFilePreviewUrlById } from '@power/runtime-vue3';
	import { getFileType } from './utils';
	//import { PcDialog } from '@/components';
	const props = defineProps({
		modelValue: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			required: true,
		},
		fileName: {
			type: String,
			required: true,
		},
		width: {
			type: String,
			default: '80%',
		},
	});
	const emit = defineEmits(['update:modelValue']);
	const fileUrl = ref('');
	const visable = computed({
		get() {
			return props.modelValue || false;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const previewType = ref('');
	// 支持的图片类型

	// 监听文件变化
	watch(
		() => props.fileName,
		(newVal) => {
			if (newVal) {
				previewType.value = getFileType(newVal);
				if (previewType.value === 'image') {
					fileUrl.value = getFilePreviewUrlById(props.id);
				} else {
					fileUrl.value = '';
					window.open(`/power-front-base/power-file-preview/?id=${props.id}&name=${props.fileName}`);
					emit('update:modelValue', false);
				}
			}
		},
		{ immediate: true },
	);
	defineExpose({ getFileType });
</script>

<style scoped></style>
